import _util from '../../utils/';

const vacationManagementService = {
	selectVacationManagement(gets, resolve, reject) {
		_util.request({
			url: '/api/HRVacationSetting/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	createVacationManagement(data, resolve, reject) {
		_util.request({
			url: '/api/HRVacationSetting/Post',
			method: 'post',
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateVacationManagement(puts, resolve, reject) {
		_util.request({
			url: '/api/HRVacationSetting/Put',
			method: "put",
			data: puts,
			success: resolve,
			error: reject
		})
	},
	deleteVacationManagement(deletes, resolve, reject) {
		_util.request({
			url: '/api/HRVacationSetting/Delete',
			method: "delete",
			data: deletes,
			success: resolve,
			error: reject
		})
	},
	selectBasicVacationManagement(gets, resolve, reject) {
		_util.request({
			url: '/api/HRVacationBasicSetting/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	selectBasicVacationManagementDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HRVacationBasicSettingRules/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
}

export default vacationManagementService;


// WEBPACK FOOTER //
// ./src/services/Attendance/vacation-management-service.js